<template>
  <div>
    <v-carousel
      height="300"
      :show-arrows="false"
      cycle
      hide-delimiter-background
    >
      <v-carousel-item v-for="(image, index) in media" :key="index">
        <div class="v-image v-responsive theme--dark rounded-lg">
          <div class="v-responsive__sizer" style="padding-bottom: 300px;"></div>
          <div style="z-index: 99; position:absolute; right: 16px;">
            <v-btn
              small
              class="mt-4 primary"
              :disabled="isReviewHidden"
              v-if="!isUserBlocked"
              @click="toggleHidePhoto(image.id, index)"
            >
              {{ image.custom_properties.is_hidden ? 'Unhide' : 'Hide' }}
            </v-btn>
          </div>
          <div
            class="v-image__image v-image__image--cover"
            :style="
              `background-color: ${
                image.custom_properties.is_hidden ||
                isUserBlocked ||
                isReviewHidden
                  ? 'grey'
                  : 'black'
              };
                background-size: auto 300px;
                background-position: center top !important;
                background-image: url(${image.url});
                opacity: ${
                  image.custom_properties.is_hidden ||
                  isUserBlocked ||
                  isReviewHidden
                    ? 0.4
                    : 1
                }`
            "
          ></div>
        </div>
      </v-carousel-item>
    </v-carousel>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  props: {
    media: {
      type: Array
    },

    mediaLoading: {
      type: Boolean,
      default: false
    },

    error: {
      type: Array
    },

    isUserBlocked: {
      type: Boolean,
      default: false
    },

    isReviewHidden: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    ...mapActions({
      toggleHideReviewPhoto: 'review/toggleHideReviewPhoto'
    }),

    toggleHidePhoto(id, index) {
      this.loading = true
      this.toggleHideReviewPhoto(id)
        .then(() => {
          this.loading = false
          this.media[index].custom_properties.is_hidden = !this.media[index]
            .custom_properties.is_hidden
          this.showSnackbar(
            `Review photo ${
              this.media[index].custom_properties.is_hidden
                ? 'restored'
                : 'hidden'
            } successfully!`
          )
        })
        .catch(err => {
          this.loading = false
          if (err.response.status === 404) {
            this.showSnackbar(
              'The photo you are trying to hide/unhide is no longer existing.',
              'error'
            )
          }
        })
    },

    showSnackbar(message, color) {
      this.snackbar.message = message
      this.snackbar.show = true
      this.snackbar.color = color
    }
  }
}
</script>
